import { render } from "./Lernvideos.vue?vue&type=template&id=eaecedce"
import script from "./Lernvideos.vue?vue&type=script&lang=js"
export * from "./Lernvideos.vue?vue&type=script&lang=js"

import "./Lernvideos.vue?vue&type=style&index=0&id=eaecedce&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__